import { classInstance } from '@/shared/helpers/helpers';

export class CatalogFilterRange {
	private readonly element: HTMLElement;
	private rangeMin: HTMLInputElement;
	private rangeMax: HTMLInputElement;
	private inputMin: HTMLInputElement;
	private inputMax: HTMLInputElement;
	private min: number;
	private max: number;
	private currentMin: number;
	private currentMax: number;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private setProgress = (): void => {
		const minValue: string = this.rangeMin.value;
		const maxValue: string = this.rangeMax.value;
		this.element.style.setProperty('--gradient-min', `${(minValue - this.min) / ((this.max - this.min) / 100)}%`);
		this.element.style.setProperty('--gradient-max', `${(maxValue - this.min) / ((this.max - this.min) / 100)}%`);
	};

	private handleRangeMinChange = ({ target }): void => {
		if (target.value >= this.currentMax) target.value = this.currentMax;
		this.currentMin = parseInt(this.rangeMin.value, 10);
		this.inputMin.value = target.value;
		this.setProgress();
		if (this.currentMin === this.max) {
			this.rangeMax.style.setProperty('z-index', '-1');
			this.rangeMax.setAttribute('disabled', '');
		} else {
			this.rangeMax.style.removeProperty('z-index');
			this.rangeMax.removeAttribute('disabled');
		}
	};

	private handleRangeMaxChange = ({ target }): void => {
		if (target.value <= this.currentMin) target.value = this.currentMin;
		this.currentMax = parseInt(this.rangeMax.value, 10);
		this.inputMax.value = target.value;
		this.setProgress();
	};

	private handleInputMinChange = ({ target }): void => {
		if (target.value >= this.currentMax) target.value = this.currentMax;
		this.rangeMin.value = target.value;
		this.rangeMin.dispatchEvent(new Event('input'));
	};

	private handleInputMaxChange = ({ target }): void => {
		if (target.value <= this.currentMin) target.value = this.currentMin;
		this.rangeMax.value = target.value;
		this.rangeMax.dispatchEvent(new Event('input'));
	};

	private handleNumericInput = ({ target }): void => {
		target.value = target.value.replace(/\D/g, '');
	};

	private setHandlers = (): void => {
		this.rangeMin.addEventListener('input', this.handleRangeMinChange);
		this.rangeMax.addEventListener('input', this.handleRangeMaxChange);
		this.inputMin.addEventListener('change', this.handleInputMinChange);
		this.inputMax.addEventListener('change', this.handleInputMaxChange);
		this.inputMin.addEventListener('input', this.handleNumericInput);
		this.inputMax.addEventListener('input', this.handleNumericInput);
	};

	private setElements = (): void => {
		this.rangeMin = this.element.querySelector('.catalog-filter-range__slider--min');
		this.rangeMax = this.element.querySelector('.catalog-filter-range__slider--max');
		this.inputMin = this.element.querySelector('.catalog-filter-range__input--min');
		this.inputMax = this.element.querySelector('.catalog-filter-range__input--max');
	};

	private setValues = (): void => {
		this.min = parseInt(this.rangeMin.min, 10);
		this.max = parseInt(this.rangeMax.max, 10);
		this.currentMin = parseInt(this.rangeMin.value, 10);
		this.currentMax = parseInt(this.rangeMax.value, 10);
	};

	public init = (): void => {
		if (classInstance.get(this.element)?.filterRange) this.reinit();
		else {
			classInstance.set(this, { filterRange: this.element });
			this.setElements();
			this.setValues();
			this.setHandlers();
			this.setProgress();
		}
	};

	public destroy = (): void => {
		this.rangeMin.removeEventListener('input', this.handleRangeMinChange);
		this.rangeMax.removeEventListener('input', this.handleRangeMaxChange);
		this.inputMin.removeEventListener('change', this.handleInputMinChange);
		this.inputMax.removeEventListener('change', this.handleInputMaxChange);
		this.rangeMin = null;
		this.rangeMax = null;
		this.inputMin = null;
		this.inputMax = null;
		this.min = null;
		this.max = null;
		this.currentMin = null;
		this.currentMax = null;
		classInstance.del(this, 'filterRange');
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
